import { Link } from "@mui/material";
import { styled } from "@mui/system";
export const ErrorSpan = styled("span")(({ theme }) => ({
    color: "#f44336",
    fontSize: "0.75rem",
    fontFamily: " Montserrat",
    fontWeight: "400",
    lineHeight: "1.66",
    display: "flex",
}));
export const StyledLink = styled(Link, {
    shouldForwardProp: (prop) => prop !== "disabled", // prevent passing 'disabled' to DOM
})(({ disabled = true }) => ({
    color: disabled ? "grey" : "inherit",
    cursor: "pointer",
    pointerEvents: disabled ? "none" : "auto",
    textDecoration: "none", // optional: remove underline if desired
}));
